import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-secondary text-secondary-foreground mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_fire-cider-shop/artifacts/3vvvwslc_IMG_1925.png" 
              alt="East Burford Ltd" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-amber-100/80 max-w-md">
              Handcrafted herbal tonics made with love in small batches. 
              Our fire cider is brewed using traditional recipes and the finest organic ingredients.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" className="text-amber-200/70 hover:text-primary transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-amber-200/70 hover:text-primary transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-amber-200/70 hover:text-primary transition-colors" aria-label="Email">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-amber-100/80 hover:text-primary transition-colors">Home</Link></li>
              <li><Link to="/products" className="text-amber-100/80 hover:text-primary transition-colors">Shop</Link></li>
              <li><Link to="/account" className="text-amber-100/80 hover:text-primary transition-colors">My Account</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-amber-100/80">
              <li>East Burford Naturals</li>
              <li>Cusson Close</li>
              <li>Brize Meadows</li>
              <li>Oxon</li>
              <li>OX18 1PG</li>
              <li className="text-primary pt-2">Tel: 07721 559336</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-amber-900/30 mt-8 pt-8 text-center text-amber-100/60 text-sm">
          <p>&copy; {new Date().getFullYear()} East Burford Naturals. All rights reserved.</p>
          <p className="font-accent text-lg mt-2 text-primary">Made with fire & love</p>
        </div>
      </div>
    </footer>
  );
};
